import { STATIC_SERVER_URL } from "config/config";
import classes from "./popUp.module.scss";
import { Link } from "react-router-dom";
import { useEffect } from "react";

function PopUp({ onPopupClose }) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onPopupClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onPopupClose]);

  return (
    <div className={classes.popupContainer}>
      <div className={classes.closeIcon} title="Bezárás" onClick={onPopupClose}>
        <svg width="65px" height="65px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z" stroke="#fff" strokeWidth="2" />
          <path d="M9 9L15 15M15 9L9 15" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </div>
      <Link to="/hirek/tamogassuk-egyutt-a-kispesti-utanpotlast/2025-04-15">
        <img src={`${STATIC_SERVER_URL}/web/images/banners/ado1_desktop_1280.png`} alt="Adó 1%" className={classes.popupImageDesktop} />
        <img src={`${STATIC_SERVER_URL}/web/images/banners/ado1_mobil_400x400.png`} alt="Adó 1%" className={classes.popupImageMobile} />
      </Link>
    </div>
  )
}

export default PopUp;
